module.exports = __webpack_public_path__ + "static/media/hamburger-menu-icon.f116286b.svg";